module.exports = __webpack_public_path__ + "images/emoji/waxing_gibbous_moon.9eb7e51649638b5db9ce.png";